import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { toaster } from 'evergreen-ui';
import { bindActionCreators } from 'redux';
import * as needRefresh from '../../../../../actions/needRefresh';
import { ButtonGear, ContainerChecklists, ContainerStatus } from './style';

import api from '../../../../../services/api';

class Status extends Component {
	state = {
		selectStatusDemand: [],
		statusDemand: '',
		checklists: [],
	};

	componentDidMount() {
		const { refresh } = this.props;

		this.requestDemand();

		if (refresh) {
			// eslint-disable-next-line react/destructuring-assignment
			return this.requestDemand();
		}

		return null;
	}

	requestDemand = async () => {
		const { demandId } = this.props;

		const response = await api.get(`/demands/${demandId}`);

		return this.setState({
			statusDemand: response.data.data.attributes.status.value,
			selectStatusDemand: response.data.data.attributes.status.options,
			checklists: response.data.data.attributes.checklists,
		});
	};

	getTotalSelecteds = option => (
		option.reduce((max, cur) => {
			if (cur.chc) {
				max += 1;
			}

			return max;
		}, 0)
	);

	handleCheck = (id) => {
		const { checklists } = this.state;

		const newChecklist = [];

		checklists.map((checklist, indice) => {
			newChecklist.push({
				id: '',
				title: '',
				options: [],
			});

			checklist.options.map((option) => {
				if (option.id === id) {
					option.chc = !option.chc;
				}

				newChecklist[indice].id = checklist.id;
				newChecklist[indice].title = checklist.title;
				newChecklist[indice].options.push(option);
				return newChecklist;
			});

			return null;
		});

		return this.setState({
			checklists: newChecklist,
		});
	};

	changeElement = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	handleSaveDemand = () => {
		const { statusDemand, checklists } = this.state;

		const { demandId } = this.props;

		const checklistsSelecteds = [];

		checklists.map(checklist => (
			checklist.options.map(option => (
				option.chc ? checklistsSelecteds.push(option.id) : null
			))
		));

		const data = {
			demand_status_id: statusDemand,
			checklists: checklistsSelecteds,
		};

		api.put(`/demands/${demandId}`, data)
			.then(() => {
				// eslint-disable-next-line react/destructuring-assignment
				this.props.needRefresh(true);
				toaster.success('Demanda atualizada com sucesso!');
			})
			.catch(() => {
				toaster.danger('Ops! Houve um erro ao atualizar sua demanda.');
			});
	};

	render() {
		const { selectStatusDemand, statusDemand, checklists } = this.state;

		return (
			<Fragment>
				<ContainerStatus>
					<label htmlFor="slc-status" className="mb-1">
						Status:
					</label>

					<select id="slc-status" onChange={e => this.changeElement(e)} name="statusDemand" value={statusDemand}>
						{
							selectStatusDemand && selectStatusDemand.map(option => (
								<option key={option.id} value={option.id}>{option.title}</option>
							))
						}
					</select>
				</ContainerStatus>

				<ContainerChecklists>
					<h3 className="title title-checklist">Check-list:</h3>
					<div className="d-flex justify-content-start checklist">
						{
							checklists && checklists.map(checklist => (
								<div className="container-checklist" key={checklist.id}>
									<p className="title-container">
										{checklist.title}
										{
											<span className="tot-selecteds">
												{this.getTotalSelecteds(checklist.options)}
												/
												{checklist.options.length}
											</span>
										}
									</p>

									{
										checklist.options.map(option => (
											<Fragment key={option.id}>
												<div className="form-check">
													<input className="form-check-input" type="checkbox" value={option.id} id={`item-${option.id}`} checked={option.chc} onChange={this.handleCheck.bind(this, option.id)} />
													<label className="form-check-label" htmlFor={`item-${option.id}`}>
														{option.title}
													</label>
												</div>
											</Fragment>
										))
									}
								</div>
							))
						}
					</div>
				</ContainerChecklists>

				<div className="container-button">
					<ButtonGear type="button" className="mt-3" onClick={() => this.handleSaveDemand()}>
						Salvar alterações
					</ButtonGear>
				</div>
			</Fragment>
		);
	}
}

const mapStateToProps = state => ({
	refresh: state.needRefresh,
});

const mapDispatchToProps = dispatch => bindActionCreators(needRefresh, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Status);
